import * as React from 'react';

export function Table({ children }) {
    return (
        <table className={'react-table'}>
            {children}
        </table>
    );
}
